import { render, staticRenderFns } from "./EmployeeRules.vue?vue&type=template&id=4917a06a&scoped=true&lang=pug"
import script from "./EmployeeRules.vue?vue&type=script&lang=js"
export * from "./EmployeeRules.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRules.vue?vue&type=style&index=0&id=4917a06a&prod&lang=scss"
import style1 from "./EmployeeRules.vue?vue&type=style&index=1&id=4917a06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917a06a",
  null
  
)

export default component.exports